<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.employeegroup') }} > {{ group.name }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            v-if="hasRoleDelete"
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <PayrollEmployeeGroupForm
        :state="group"
        :isSubmitted="isSubmitted"
        :employees="employees"
        :disabled="disabled || !hasRoleEdit"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      query: {
        id: this.$route.query.id,
        name: this.$route.query.name,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  computed: {
    ...mapState('hrm', {
      employees: 'employeeList',
    }),
    ...mapState('payroll', {
      group: 'employeeGroupSingle',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
    }),
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 2,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, [{
      'name': this.query.name,
      'router': {
        'name': 'PaySlipConditionEdit',
        'query': {
          id: this.query.id,
          name: this.query.name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 1,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('hrm', {
      getEmployeeList: 'getEmployeeList',
    }),
    ...mapActions('payroll', {
      getEmployeeGroupSingle: 'getEmployeeGroupSingle',
      updateEmployeeGroup: 'updateEmployeeGroup',
      updateEmployeeGroupAssign: 'updateEmployeeGroupAssign',
      deleteEmployeeGroup: 'deleteEmployeeGroup',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getEmployeeList(params),
        this.getEmployeeGroupSingle(this.query.id),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit ({ name, assignIds = [] }) {
      this.disabled = true
      this.isSubmitted = true
      const responseUpdate = await this.updateEmployeeGroup({ id: this.query.id, data: { name } })
      const responseUpdateAssign = await this.updateEmployeeGroupAssign({ id: this.query.id, data: { emp_ids: assignIds } })
      if (responseUpdate.success && responseUpdateAssign.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: name }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteEmployeeGroup(this.query.id)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.group.name }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'EmployeeGroupList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/group/Edit.vue